import { EventEmitter } from "@shop/frontend/web/js/components/EventEmitter";

export class BottomPane {
	constructor() {
		this.emitter = new EventEmitter();

		this.$bottom = $("#js-bottom-pane");

		this.initPane();
	}

	initPane() {
		this.setUpPaneListeners();
	}

	setUpPaneListeners() {
		$(document).on("click", ".js-bottom-pane-move", () => this.togglePane());
	}

	pane(action, fn) {
		if (action === "expanded") this.emitter.subscribe("event:expanded", () => fn());

		if (action === "reduced") this.emitter.subscribe("event:reduced", () => fn());

		if (action === "show") this.emitter.subscribe("event:show-pane", () => fn());

		if (action === "hide") this.emitter.subscribe("event:hide-pane", () => fn());
	}

	togglePane() {
		return this.$bottom.hasClass("expanded") ? this.reduce() : this.expand();
	}

	expand() {
		this.$bottom.addClass("expanded");
		$('.js-show-tickets')?.text('Скрыть');

		return this.emitter.emit("event:expanded");
	}

	reduce() {
		this.$bottom.removeClass("expanded");
		$('.js-show-tickets')?.text('Показать');

		return this.emitter.emit("event:reduced");
	}

	show() {
		this.$bottom.addClass("active");

		return this.emitter.emit("event:show-pane");
	}

	hide() {
		this.reduce();
		this.$bottom.removeClass("active");

		return this.emitter.emit("event:hide-pane");
	}
}
